import { NestFactory } from '@nestjs/core';
import { AppModule } from './app/app.module';
import { SwaggerModule, DocumentBuilder } from '@nestjs/swagger';
import { Logger, ValidationPipe } from '@nestjs/common';
import { jobConfigs } from '../config';
import * as bodyParser from 'body-parser';

const port = jobConfigs.port;
async function bootstrap() {
  const app = await NestFactory.create(AppModule, {});
  app.enableCors();
  const options = new DocumentBuilder()
    .setTitle('JobManagementModule ')
    .setDescription('The SFCS 2.0 API description')
    .setVersion('2.0')
    // .setBasePath(`${jobConfigs.swagger.basePath}`)
    .addBearerAuth()
    .addTag('sfcs')
    .build();
  const document = SwaggerModule.createDocument(app, options);
  SwaggerModule.setup('api', app, document);
  app.use(bodyParser.json({limit: '1mb'}));
  app.use(bodyParser.urlencoded({limit: '1mb', extended: true}));
  app.useGlobalPipes(new ValidationPipe({ validationError: { target: false } }));
  const server = await app.listen(port);
  server.setTimeout(1000 * jobConfigs.responseTimeOut);
  console.log(`Server running at port ${port}`)
}

bootstrap();
